<template>
      <el-form :model="model" :rules="rules" ref="refForm" size="small" label-width="110px" class="demo-ruleForm">
           <el-form-item label="外接设备名称" prop="controlDevcName">
                <el-input
                  class="input_box text_center_input"
                  placeholder="请输入设备名称"
                  v-model="model.controlDevcName">
                </el-input>
            </el-form-item>
        
         
            
      </el-form> 
</template>

<script>
    import { deepClone,mapTo } from '@/libs/util'
    export default {
        props:{
            row:{
                type:Object,
                default:()=>{}
            },
            devId:{
                type:String,
                default:''
            }
        },
        data(){
            return {
                model:{
                     "id": "",
                      "controlDevcName": ""
                },
                rules: {
         
                    controlDevcName: [
                      { required: true, message: '请输入设备名称', trigger: 'blur' }

                    ],
                   
                    
                
                },
            }
        },
        created(){
           
            if(this.row){
                mapTo(this.row,this.model)
            }
            this.model.id = this.devId
        },
        submit (dialog, callback) {
            this.$refs.refForm.validate( async(valid) => {
                if (valid) {
                     const res = await this.$api.EditJKBLExternalData(this.model)
                     if(res){
                        callback();
                        dialog.okLoading = false;
                        dialog.close();
                        setTimeout(() => {
                            this.$msg.success('设置成功')
                        }, 500);
                     }
                
              
                
                } 
            });
        
        },
        methods:{
          
        }
    }
</script>

<style lang="scss" scoped>
.demo-ruleForm{
  margin-top: 20px;
}
</style>